const config = {
    // Local development backend - ACTIVE
    backendUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
    websocketUrl: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:8000/ws/',
    // UAT backend (commented out for local development)
    // backendUrl: 'https://api-uat.wennze.com/api',
    // websocketUrl: 'wss://api-uat.wennze.com/ws/',
    environment: process.env.NODE_ENV,
    debug: true // Force debug mode for local testing
};

// Remove trailing slashes from URLs
config.backendUrl = config.backendUrl.replace(/\/+$/, '');
config.websocketUrl = config.websocketUrl.replace(/\/+$/, '/'); // Keep one trailing slash for WebSocket

// Ensure api prefix exists for REST endpoints
if (!config.backendUrl.includes('/api')) {
    config.backendUrl = `${config.backendUrl}/api`;
}

// Log configuration in non-production environments
if (config.debug) {

}

export default config;